const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_URLS = {
  default: API_BASE_URL,
  login: `${API_BASE_URL}/api/auth/login`,
  register: `${API_BASE_URL}/api/auth/register`,
  verifyPhone: `${API_BASE_URL}/api/auth/verify-phone`,
  resendPhoneVerification: `${API_BASE_URL}/api/auth/resend-phone-verification`,
  updatePhoneNumber: `${API_BASE_URL}/api/auth/update-phone-number`,
  changePassword: `${API_BASE_URL}/api/auth/change-password`,
  forgotPassword: `${API_BASE_URL}/api/auth/forgot-password`,
  resetPassword: `${API_BASE_URL}/api/auth/reset-password`,
  validateResetToken: `${API_BASE_URL}/api/auth/validate-reset-token`,
  profile: `${API_BASE_URL}/api/auth/profile`,
  updateProfile: `${API_BASE_URL}/api/users/profile`,
  vehicles: `${API_BASE_URL}/api/vehicles`,
  rides: {
    driver: `${API_BASE_URL}/api/rides/driver`,
    create: `${API_BASE_URL}/api/rides`,
    available: `${API_BASE_URL}/api/rides/available`
  },
  bookings: {
    driver: `${API_BASE_URL}/api/bookings/driver`,
    rider: `${API_BASE_URL}/api/bookings/rider`,
    create: `${API_BASE_URL}/api/bookings`,
    request: `${API_BASE_URL}/api/bookings/request`,
    requests: `${API_BASE_URL}/api/ride-requests`
  },
  church: `${API_BASE_URL}/api/church`,
  vehicleSetDefault: (id) => `${API_BASE_URL}/api/vehicles/${id}/default`,
  admin: {
    dashboard: `${API_BASE_URL}/api/admin/dashboard`,
    users: `${API_BASE_URL}/api/admin/users`,
    rides: `${API_BASE_URL}/api/admin/rides`,
    bookings: `${API_BASE_URL}/api/admin/bookings`,
    assignBookingToRide: (bookingId) => `${API_BASE_URL}/api/admin/bookings/${bookingId}/assign-ride`,
    pendingDrivers: `${API_BASE_URL}/api/admin/pending-drivers`,
    approveDriver: (id) => `${API_BASE_URL}/api/admin/drivers/${id}/approve`,
    rejectDriver: (id) => `${API_BASE_URL}/api/admin/drivers/${id}/reject`,
    analytics: `${API_BASE_URL}/api/admin/analytics`,
    settings: {
      churchAddress: `${API_BASE_URL}/api/admin/settings/church-address`,
      services: `${API_BASE_URL}/api/admin/settings/services`
    },
    drivers: `${API_BASE_URL}/api/admin/drivers`,
    riders: `${API_BASE_URL}/api/admin/riders`,
    admins: `${API_BASE_URL}/api/admin/admins`
  }
};

export default API_URLS; 